export const 매니저전용_쿼리키 = {
  샵목록: ['샵목록'] as const,
};
